import { Component, OnInit, Input, ElementRef, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Params } from "@angular/router";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";

import { CrudService } from "./../../../crud/crud.service";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import "jspdf-autotable";

import * as moment from "moment";
import * as $ from "jquery";
import { environment } from '../../../../environments/environment';

import { Mensaje } from "../../../mensaje";
import { NotificationsService } from 'angular2-notifications';
import { isUndefined } from "util";

@Component({
  selector: "app-horario-formulario",
  templateUrl: "./formulario.component.html",
  styleUrls: ["./formulario.component.css"]
})
export class FormularioComponent implements OnInit {
  @ViewChild("periodoAnterior") periodoAnterior: ElementRef;
  @ViewChild("modalidad") modalidad: ElementRef;
  @ViewChild("tipoPeriodo") tipoPeriodo: ElementRef;

  dato: FormGroup;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  API_PATH = environment.API_PATH;
  contador_cambio = 0;
  hacer = true;
  date = new Date();
  tab = 0;
  MinDate = moment(
    new Date(this.date.getFullYear(), this.date.getMonth(), 1)
  ).format("YYYY-MM-DD");
  tieneid = false;
  grupos = [];
  turnos = [];
  profesores_horarios = [];
  profesorhorario;
  ph_modulos = [];
  ph_dias = [];
  ph_horas = [];
  ph_modalidades = [];

  dias_semanas = ["Ninguno", "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sabado"];

  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";

  imprimirhorario = false;
  modulos = {
    modulos: 0
  };
  modulos_periodos_escolares = {};
  profesores = [];
  horarios_dias;
  temp_horarios_dias = [];
  horarios_detalles;
  dias_semanas_id;

  hora_inicio;
  duracion_clase;
  inicio_edit = false;
  cargando = false;

  profesores_configurados = [];

  dias = [
    "DOMINGO",
    "LUNES",
    "MARTES",
    "MIERCOLES",
    "JUEVES",
    "VIERNES",
    "SABADO"
  ];
  limpiarIndex;
  limpiarIndem;

  grupo_sel;
  mensajeResponse: Mensaje = new Mensaje(true);
  //mostrar notificaciones
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  materias = [];

  width = document.body.clientWidth;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private crud: CrudService,
    private notificacion: NotificationsService
  ) { }

  ngOnInit() {
    this.dato = this.fb.group({
      periodos_escolares_id: ["", [Validators.required]],
      periodos_escolares: this.fb.group({}),
      carreras_planes_id: ["", [Validators.required]],
      carreras_planes: this.fb.group({}),
      modalidades_id: [""],
      modalidades: this.fb.group({}),
      grupos_id: [""],
      grupos: this.fb.group({}),
      temp_grupos_id: ["", [Validators.required]],
      turnos_id: ["", [Validators.required]],
      turnos: this.fb.group({}),
      modulos_periodos_escolares: this.fb.array([])
    });

    this.modulos_periodos_escolares = {
      modulos_periodos_escolares_id: [""],
      nombre: [""],
      horarios_dias: this.fb.array([])
    };

    // array de dias
    this.horarios_dias = {
      dias_semanas_id: ["", [Validators.required]],
      horarios_detalles: this.fb.array([])
    };

    // array de horas por dia
    this.horarios_detalles = {
      materias_id: ["", [Validators.required]],
      personas_id: ["", [Validators.required]],
      hora_inicio: ["", [Validators.required]],
      hora_termino: ["", [Validators.required]]
    };

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
    
    this.route.params.subscribe(params => {
      
      if (params["id"]) {
        this.tieneid = true;
        this.hacer = false;
      }
    });
  }

  // rellenar los grupo segun el period y la carrera
  carrera_plan(event: any, modelo, url: string = "", item, periodos_escolares) {
    
      this.grupos = [];
    
      const id = this.dato.controls["periodos_escolares_id"].value;
      periodos_escolares.forEach(element => {
        if (element.id == id) {
          this.modulos_periodos_escolares = element.modulos_periodos_escolares;
          this.dato.controls.modalidades_id.patchValue(element.modalidades_id);
        }
      });
      this.dato.controls.temp_grupos_id.patchValue("");

      if (url != "" && this.dato.controls["carreras_planes_id"].value != '') {
        this.cargando = true;
        this.crud
          .lista(
            this.parametros,
            url +
            "?es_horario=1&carreras_planes_id=" +
            this.dato.controls["carreras_planes_id"].value +
            "&periodos_escolares_id=" +
            this.dato.controls["periodos_escolares_id"].value +
            "&grupos_id=" +
            this.dato.controls["grupos_id"].value
          )
          .subscribe( 
            resultado => {console.log(resultado);
              if (resultado.data.length > 0) {
                resultado.data.forEach((element, indice) => {
                  
                  if (!element.text) element.text = element.nombre;
                  if (this.dato.controls.grupos_id.value == element.id) {
                    this.dato.controls.temp_grupos_id.patchValue(indice);
                    this.grupo_sel = element;
                  }
                });
                this.grupos = resultado.data;
                if (this.tieneid) {
                  document.getElementById("cargar_horario").click();
                }
              } else {
                this.mensajeResponse.titulo = "Sin grupos";
                this.mensajeResponse.texto =
                  "Esta Carrera / Plan no tiene grupos.";
                this.mensajeResponse.clase = "danger";
                this.mensaje(5);
              }
              this.cargando = false;
            },
            error => {
              this.cargando = false;
            }
          );
      }
    
  }

  // este metodo se carga solo en edit para mostrar los datos cargados en la bd
  iniciar_horario() {
    try {
      this.materias = [];
      setTimeout(() => {
        // cargar turnos y materias disponibles
        const id = this.dato.controls["grupos_id"].value;
        this.grupos.forEach(element => {
          if (element.id == id) {
            if (element.carreras_planes.materias.length > 0) {
              this.materias = element.carreras_planes.materias;
              this.materias.forEach(mtr => {
                mtr.text = mtr.nombre;
              });
            }
            if (
              element.periodos_escolares.modalidades.modalidades_dias.length > 0
            ) {
              let c = 0;
              element.periodos_escolares.modalidades.modalidades_dias.forEach(
                ele => {
                  if (c == 0) {
                    this.dias_semanas_id = ele.dias_semanas_id;
                    // cargar turnos disponibles
                    this.crud
                      .lista(
                        this.parametros,
                        "horario-turnos" +
                        "?modalidades_id=" +
                        this.dato.controls["modalidades_id"].value +
                        "&dias_semanas_id=" +
                        this.dias_semanas_id +
                        "&carreras_planes_id=" +
                        this.dato.controls.carreras_planes_id.value
                      )
                      .subscribe(
                        resultado => {
                          this.turnos = resultado.data;

                          this.seleccionar_turno();
                        },
                        error => { }
                      );
                  }
                  c++;
                }
              );
            }
          }
        });
        
        // cargar los profesores de cada hora por dia y materia
        this.inicio_edit = true;
        this.dato.controls.modulos_periodos_escolares["controls"].forEach(
          (modulo, cm) => {
            modulo.controls.horarios_dias["controls"].forEach(item => {
              let i = 0;
              item.controls.horarios_detalles["controls"].forEach(val => {
                this.cargar_profesores(val.controls, cm, item, i);
                i++;
              });
            });
          }
        );
      }, 300);
      this.inicio_edit = false;
    } catch (e) {
      console.log(e);
    }
  }

  // iniciar los dias que tenga asignado el grupo segun su modalidad
  iniciar_dias_grupo(modelo) {
    try {
      this.materias = [];
      let sinmaterias = false;
      this.grupo_sel = this.grupos[this.dato.controls.temp_grupos_id.value];

      this.dato.controls.grupos_id.patchValue(
        this.grupos[this.dato.controls.temp_grupos_id.value].id
      );
      this.dato.controls["turnos_id"].patchValue(
        this.grupos[this.dato.controls.temp_grupos_id.value].turnos_id
      );
      const id = this.dato.controls["grupos_id"].value;
      if (this.grupos.length > 0) {
        this.grupos.forEach(element => {
          if (element.id == id) {
            if (element.turnos_id != "" && element.turnos_id != null) {
              // comprobar y asignar las materias
              if (element.carreras_planes.materias) {
                if (element.carreras_planes.materias.length > 0) {
                  let materias_fuera_nivel = true;
                  element.carreras_planes.materias.forEach(mtr => {
                    if (mtr.nivel == element.nivel) {
                      mtr.text = mtr.nombre;
                      this.materias.push(mtr);
                      materias_fuera_nivel = false;
                    }
                  });
                  if (materias_fuera_nivel) {
                    this.mensajeResponse.titulo = "Materias Fuera";
                    this.mensajeResponse.texto =
                      "Este grupo para este nivel tiene mal configurado las materias";
                    this.mensajeResponse.clase = "danger";
                    this.mensaje(5);
                  }
                } else {
                  sinmaterias = true;
                }
              } else {
                sinmaterias = true;
              }
              if (sinmaterias) {
                this.mensajeResponse.titulo = "No Configurado";
                this.mensajeResponse.texto =
                  "Esta plan no tiene configurado las materias.";
                this.mensajeResponse.clase = "warning";
                this.mensaje(5);
              }
              // comprobar los dias asignados
              if (
                element.periodos_escolares.modalidades.modalidades_dias.length >
                0
              ) {
                let c = 0;
                // vaciar el tabular de horarios
                while (modelo.controls.length) {
                  modelo.removeAt(modelo.controls.length - 1);
                }
                this.crud
                  .lista(
                    this.parametros,
                    "horario-modulos" +
                    "?modalidades_id=" +
                    this.dato.controls["modalidades_id"].value +
                    "&nivel=" +
                    this.grupos[this.dato.controls.temp_grupos_id.value]
                      .nivel +
                    "&carreras_planes_id=" +
                    this.dato.controls.carreras_planes_id.value
                  )
                  .subscribe(
                    resultado => {
                      this.modulos = resultado.data;
                      this.horarios_dias.horarios_detalles = this.fb.array([]);
                      this.dato.controls.modulos_periodos_escolares = this.fb.array(
                        []
                      );
                      let dias_semana = [];

                      element.periodos_escolares.modalidades.modalidades_dias.forEach(
                        ele => {
                          if (c == 0) {
                            this.dias_semanas_id = ele.dias_semanas_id;
                            // cargar turnos disponibles
                            this.crud
                              .lista(
                                this.parametros,
                                "horario-turnos" +
                                "?modalidades_id=" +
                                this.dato.controls["modalidades_id"].value +
                                "&dias_semanas_id=" +
                                this.dias_semanas_id +
                                "&carreras_planes_id=" +
                                this.dato.controls.carreras_planes_id.value
                              )
                              .subscribe(
                                resultado => {
                                  this.turnos = resultado.data;
                                  this.seleccionar_turno();
                                },
                                error => { }
                              );
                          }
                          dias_semana.push(ele.dias_semanas_id);
                          c++;
                        }
                      );

                      if (this.modulos) {
                        const mpe = <FormArray>(
                          this.dato.controls.modulos_periodos_escolares
                        );

                        for (let key = 0; key < this.modulos.modulos; key++) {
                          this.temp_horarios_dias = [];

                          dias_semana.forEach(semana => {
                            this.horarios_dias = {
                              dias_semanas_id: [semana, [Validators.required]],
                              horarios_detalles: this.fb.array([])
                            };
                            this.temp_horarios_dias.push(
                              this.fb.group(this.horarios_dias)
                            );
                          });
                          let parciales = [];
                          for (
                            let par = 1;
                            par <=
                            this.grupos[this.dato.controls.temp_grupos_id.value]
                              .periodos_escolares.modalidades.numero_parciales;
                            par++
                          ) {
                            let parcial = {
                              numero_parcial: [par, [Validators.required]],
                              dias_reportar_calificacion: [
                                "",
                                [Validators.required]
                              ],
                              fecha_inicio: ["", [Validators.required]],
                              fecha_fin: ["", [Validators.required]]
                            };
                            parciales.push(this.fb.group(parcial));
                          }

                          let modulos_periodos = {
                            id: [""],
                            nombre: [
                              "Módulo " + (key + 1),
                              [Validators.required]
                            ],
                            fecha_inicio: ["", [Validators.required]],
                            fecha_fin: ["", [Validators.required]],
                            horarios_dias: this.fb.array(
                              this.temp_horarios_dias
                            ),
                            periodos_escolares_parciales: this.fb.array(
                              parciales
                            )
                          };
                          mpe.controls.push(this.fb.group(modulos_periodos));
                        }
                      } else {
                        this.mensajeResponse.titulo = "No Configurado";
                        this.mensajeResponse.texto =
                          "Esta carrera plan no esta modularizada.";
                        this.mensajeResponse.clase = "warning";
                        this.mensaje(5);
                      }
                    },
                    error => { }
                  );

                // crargar los turnos disponibles
              } else {
                this.mensajeResponse.titulo = "No Configurado";
                this.mensajeResponse.texto =
                  "Esta modalidad para este periodo no tiene configurado los días.";
                this.mensajeResponse.clase = "warning";
                this.mensaje(5);
              }
            } else {
              this.mensajeResponse.titulo = "No Configurado";
              this.mensajeResponse.texto =
                "Esta grupo no tiene asignado un turno.";
              this.mensajeResponse.clase = "warning";
              this.mensaje(5);
            }
          }
        });
      } else {
        this.mensajeResponse.titulo = "Sin grupos";
        this.mensajeResponse.texto = "Esta Carrera / Plan no tiene grupos.";
        this.mensajeResponse.clase = "danger";
        this.mensaje(5);
      }
    } catch (e) {
      console.log(e);
    }
  }

  // seleccionar un turno y asignar la duracion y el inicio de clases
  seleccionar_turno() {
    const id = this.dato.controls["turnos_id"].value;
    this.turnos.forEach(element => {
      if (element.id == id) {
        this.hora_inicio = moment(element.hora_inicio, "HH:mm").format("HH:mm");
        this.duracion_clase = element.duracion_clase;

        this.horarios_detalles.hora_inicio = [
          "",
          [Validators.required, Validators.min(this.hora_inicio)]
        ];
      }
    });
  }

  // abre el modal para preguntar si desea limpiar un dia
  iniciar_limpiar(im, i) {
    this.limpiarIndem = im;
    this.limpiarIndex = i;
    document.getElementById("confirmarLimpiar").classList.add("is-active");
  }

  // limpia el dia
  limpiar_dia(modelo, i) {
    modelo[i]["controls"]["horarios_detalles"] = this.fb.array([]);
    document.getElementById("confirmarLimpiar").classList.remove("is-active");
  }

  // calcula la hora de termino
  time_cal;;
  calcular_horan_fin(hora, modulo, modelo, horario, i) {
    clearTimeout(this.time_cal);
    this.time_cal = setTimeout(() => {
      this.calcular_horan_termino(hora, modulo, modelo, horario, i);
    }, 500);
  }
  calcular_horan_termino(hora, modulo, modelo, horario, i) {
    try {
      const fin = moment(hora, "HH:mm").add(this.duracion_clase, "minutes").format("HH:mm");
      modelo.hora_termino.patchValue(fin);
      let existe = false;
      let c = 0;
      horario.controls.horarios_detalles.controls.forEach(element => {
        if (hora > element.value.hora_inicio && hora < element.value.hora_termino && c != i) {
          existe = true;
        }
        c++;
      });
      // valida que la hora sea unica
      if (existe) {
        this.mensajeResponse.titulo = "Hora";
        this.mensajeResponse.texto = "Esta hora ya esta ocupada para este día.";
        this.mensajeResponse.clase = "danger";
        this.mensaje(5);
      } else {
        if (modelo.hora_termino.value.length == 5 && modelo.materias_id.value != "") {
          this.cargar_profesores(modelo, modulo, horario, i);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  // cambiar materia para cargar los profesores disponibles
  cambiar_materia(modelo, modulo, horario, i) {
    setTimeout(() => {
      this.cargar_profesores(modelo, modulo, horario, i);
    }, 100);

  }

  // busca los porfesores disponibles en la hora y materia
  cargar_profesores(modelo, modulo, horario, i) {
    try {
      this.cargando = true;
      this.crud
        .lista(
          this.parametros,
          "horario-profesores" +
          "?inicio_edit=" +
          this.inicio_edit +
          "&periodos_escolares_id=" +
          this.dato.controls["periodos_escolares_id"].value +
          "&carreras_planes_id=" +
          this.dato.controls.carreras_planes_id.value +
          "&grupos_id=" +
          this.dato.controls.grupos_id.value +
          "&materias_id=" +
          modelo.materias_id.value +
          "&dias_semanas_id=" +
          horario.controls.dias_semanas_id.value +
          "&hora_inicio=" +
          modelo.hora_inicio.value +
          "&hora_termino=" +
          modelo.hora_termino.value
        )
        .subscribe(
          resultado => {
            this.cargando = false;
            if (!this.profesores[modulo]) {
              this.profesores[modulo] = [];
              this.profesores_configurados[modulo] = [];
            }
            if (!this.profesores[modulo][horario.controls.dias_semanas_id.value]) {
              this.profesores[modulo][horario.controls.dias_semanas_id.value] = [];
              this.profesores_configurados[modulo][horario.controls.dias_semanas_id.value] = [];
            }
            this.profesores[modulo][horario.controls.dias_semanas_id.value][i] = resultado.data;
            this.profesores_configurados[modulo][horario.controls.dias_semanas_id.value][i] = resultado.profesores_configurados;
            if (resultado.data.length == 0) {
              this.mensajeResponse.titulo = "Sin profesor";
              this.mensajeResponse.texto =
                "No hay profesor para esta materia en esta hora.";
              this.mensajeResponse.clase = "warning";
              this.mensaje(5);
            }

          },
          error => {
            this.cargando = false;
          }
        );
    } catch (e) {
      this.cargando = false;
    }
  }
  parametros = {
    pagina: 0,
    limite: 0
  };
  profesorHorarioMetodo(event) {
    if (event) {
      try {
        if (event.hasOwnProperty("value")) {
          event = event.value;
        }
        this.cargando = true;
        this.ph_modulos = [];
        this.ph_dias = [];
        this.ph_horas = [];
        this.ph_modalidades = [];
        this.profesorhorario = [];
        this.profesorhorario.horario = [];
        this.crud
          .lista(
            this.parametros,
            "profesor-horario" +
            "?periodos_escolares_id=" +
            this.dato.controls["periodos_escolares_id"].value +
            "&carreras_planes_id=" +
            this.dato.controls.carreras_planes_id.value +
            "&personas_id=" +
            event
          )
          .subscribe(
            resultado => {
              this.cargando = false;
              if (resultado.status == 200) {
                let ph_horas = [];
                let ph_dias = [];
                let ph_modulos = [];
                let ph_modalidades = [];
                this.profesorhorario = resultado.data;

                this.profesorhorario.horario = [];
                this.profesorhorario.modulos_periodos_escolares.forEach(
                  element => {

                    let elmodulo =
                      element.fecha_inicio + " al " + element.fecha_fin;
                    let modalidad = element.modalidades.nombre;
                    ph_modalidades.push(modalidad);
                    if (typeof ph_horas[modalidad] == "undefined")
                      ph_horas[modalidad] = [];
                    if (typeof ph_dias[modalidad] == "undefined")
                      ph_dias[modalidad] = [];
                    if (typeof ph_modulos[modalidad] == "undefined")
                      ph_modulos[modalidad] = [];

                    ph_modulos[modalidad].push(elmodulo);

                    if (typeof this.profesorhorario.horario == "undefined")
                      this.profesorhorario.horario = [];

                    if (typeof this.profesorhorario.horario[modalidad] == "undefined")
                      this.profesorhorario.horario[modalidad] = [];

                    if (typeof this.profesorhorario.horario[modalidad][elmodulo] == "undefined")
                      this.profesorhorario.horario[modalidad][elmodulo] = [];

                    element.horarios_dias.forEach(elem => {
                      ph_dias[modalidad].push(elem.dias_semanas.id);
                      if (typeof this.profesorhorario.horario[modalidad][elmodulo][elem.dias_semanas.id] == "undefined")
                        this.profesorhorario.horario[modalidad][elmodulo][elem.dias_semanas.id] = [];

                      elem.horarios_detalles.forEach(el => {
                        let elhora = el.hora_inicio + "-" + el.hora_termino;
                        if (typeof this.profesorhorario.horario[modalidad][elmodulo][elem.dias_semanas.id][elhora] == "undefined")
                          this.profesorhorario.horario[modalidad][elmodulo][elem.dias_semanas.id][elhora] = null;

                        if (el.materias.nombre && el.materias.nombre != "") {
                          this.profesorhorario.horario[modalidad][elmodulo][elem.dias_semanas.id][elhora] = {
                            nombre: el.materias.nombre,
                            clave: el.materias.clave,
                            grupo: element.grupos.clave + " " + element.grupos.nivel + " " + element.grupos.identificador,
                            modalidad: element.modalidades.nombre,
                            turno: element.turnos.nombre
                          };
                          ph_horas[modalidad].push(elhora);
                        }
                      });
                    });
                  }
                );
                this.ph_modalidades = this.arrayUnico(ph_modalidades);

                ph_modalidades.forEach(modalidad => {
                  this.ph_horas[modalidad] = this.arrayUnico(ph_horas[modalidad]).sort();
                  this.ph_dias[modalidad] = this.arrayUnico(ph_dias[modalidad]).sort();
                  this.ph_modulos[modalidad] = this.arrayUnico(ph_modulos[modalidad]);
                });
              }
            },
            error => { }
          );
      } catch (e) {
        this.cargando = false;
        console.log(e);
      }
    }
  }

  arrayUnico(array) {
    return array.filter(function (valor, indiceActual, arreglo) {
      let indiceAlBuscar = arreglo.indexOf(valor);
      if (indiceActual === indiceAlBuscar) {
        return true;
      } else {
        return false;
      }
    });
  }
  /**
   * Este método muestra los mensajes resultantes de los llamados de la api
   * @param cuentaAtras numero de segundo a esperar para que el mensaje desaparezca solo
   * @param posicion  array de posicion [vertical, horizontal]
   * @return void
   */
  mensaje(
    cuentaAtras: number = 6,
    posicion: any[] = ["middle", "center"]
  ): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }

  iniciarProfesor() {
    this.imprimirhorario = false;
    this.profesorhorario = [];
    this.ph_modulos = [];
    setTimeout(() => {
      document.getElementById("profesor-horario").classList.add("is-active");
    }, 100);
  }
  generarPDF() {
    let doc = new jsPDF("landscape", "mm", "letter");
    let arrays = this.dato.getRawValue();
    let periodos_escolares = arrays.modulos_periodos_escolares;
    periodos_escolares.forEach((modulo, i) => {
      let logo =
        this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "") doc.addImage(logo, "PNG", 10, 5, 26, 26, "", "FAST");

      if (this.logo_carrera != "")
        doc.addImage(this.logo_carrera, "PNG", 210, 5, 26, 26, "", "FAST");
      //Nombre empresa
      doc.setFontSize(15);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre, 140, 12, { align: "center" });

      doc.setFontSize(14);
      doc.setFont("helvetica", "", "bold");
      doc.text(this.configuracion.empresa.subnombre, 140, 18, { align: "center" });

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "normal");
      doc.text("Campus: " + this.configuracion.sucursal.nombre, 140, 24, { align: "center" });

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.text("HORARIO DE GRUPO", 140, 30, { align: "center" });

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");
      doc.text("Periodo: " + arrays.periodos_escolares.nombre + " Carrera: " + arrays.carreras_planes.carreras.nombre, 140, 35, { align: "center" });
      doc.text(" Grupo: " + arrays.grupos.clave + " Modalidad: " + arrays.modalidades.nombre + " Turno: " + arrays.turnos.nombre + " (" + modulo.nombre +
        " - del " +
        modulo.fecha_inicio +
        " a " +
        modulo.fecha_fin +
        ")", 140, 40,
        { align: "center" }
      );

      doc.rect(5, 43, 269, 166);

      let n_dias;
      let divisiones_dias;
      let n_materias;
      let divisiones_materias;
      let divisiones_materias_array = [];
      let lineX = 5;
      let lineY = 55;
      let vueltasD = 0;
      let vueltasJ = 0;
      let vueltasK = 0;
      let vuelta_division_menor = 0;
      let titulo_dias;
      let titulo_materiaX;
      let titulo_materiaY;
      let titulo_docenteX;
      let titulo_docenteY;
      let horario_inicio_X;
      let horario_inicio_Y;
      let horario_fin_X;
      let horario_fin_y;

      let lineXX = 0;
      let lineXXX = 5;
      modulo.horarios_dias.forEach((dia, j) => {
        n_dias = periodos_escolares[i].horarios_dias.length;
        divisiones_dias = 269 / n_dias;

        doc.setFontSize(10);
        vueltasD++;
        if (vueltasJ < 1) {
          titulo_dias = divisiones_dias / 2 + 5;
          vueltasJ++;
        } else {
          titulo_dias = titulo_dias + divisiones_dias;
        }

        doc.text(dia.dias_semanas.nombre, titulo_dias, 48.5, { align: "center" });
        doc.line(5, 50, 274, 50);

        lineX = lineX + divisiones_dias;
        doc.line(lineX, 43, lineX, 209);

        titulo_materiaY = 0;
        vueltasK = 0;
        lineY = 50;
        dia.horarios_detalles.forEach((detalle, k) => {
          n_materias = dia.horarios_detalles.length;
          var splitMateria = doc.splitTextToSize(detalle.materias.nombre, 40);
          var splitProfeso = doc.splitTextToSize(detalle.personas ? detalle.personas.nombre : '', 40);
          divisiones_materias = 166 / n_materias;

          titulo_materiaX = titulo_dias;

          if (vueltasK < 1) {
            titulo_materiaY = divisiones_materias / 2 + 50;
            vueltasK++;
          } else {
            titulo_materiaY = titulo_materiaY + divisiones_materias;
          }

          titulo_materiaY = titulo_materiaY - (splitMateria.length > 1 ? splitMateria.length * 2 : 0) - (splitProfeso.length > 1 ? splitProfeso.length * 2 : 0);

          doc.setFontSize(8);

          horario_inicio_X = titulo_materiaX;
          horario_inicio_Y = titulo_materiaY + (splitMateria.length > 1 ? splitMateria.length * 5 : 5);

          titulo_docenteX = horario_inicio_X;
          titulo_docenteY = horario_inicio_Y + (splitMateria.length > 1 ? splitMateria.length * 5 : 5);


          doc.text(
            splitMateria,
            titulo_materiaX + lineXX,
            titulo_materiaY,
            { align: "center" }
          );

          doc.text(
            detalle.hora_inicio + " - " + detalle.hora_termino,
            horario_inicio_X + lineXX,
            horario_inicio_Y,
            { align: "center" }
          );


          doc.text(
            splitProfeso,
            titulo_docenteX + lineXX,
            titulo_docenteY,
            { align: "center" }
          );

          lineY = lineY + divisiones_materias;
          let linesupx = 0;
          let lineinfx = 0;
          if (vueltasD == 1) {
            lineinfx = lineXXX + lineXX;
            linesupx = lineXX + lineX;
          } else {
            lineinfx = divisiones_dias * (vueltasD - 1) + 5;
            linesupx = divisiones_dias * vueltasD + 5;
          }
          doc.line(lineinfx, lineY, linesupx, lineY);
        });
        if (vueltasJ == 1) {
          lineXX = lineXX - lineX;
          lineXXX = lineXXX - 5;
        }
        lineXX += lineX;
        lineXXX += lineX;
      });

      if (i < periodos_escolares.length - 1) doc.addPage();
    });

    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "horario.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }
  generarPDFTabla() {
    if (this.profesorhorario.modalidades.modalidades_dias.length > 2) {
      this.generarPDFTablaEscolarizado();
    } else {
      this.generarPDFTablaSemiEscolarizado();
    }
  }

  generarPDFTablaEscolarizado() {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    let doc = new jsPDF("landscape", "mm", "letter");
    let arrays = this.dato.getRawValue();
    let periodos_escolares = arrays.modulos_periodos_escolares;

    this.ph_modulos.forEach((modulo, i) => {
      let logo =
        this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "") doc.addImage(logo, "PNG", 10, 5, 26, 26, "", "FAST");

      if (this.logo_carrera != "")
        doc.addImage(this.logo_carrera, "PNG", 210, 5, 26, 26, "", "FAST");
      //Nombre empresa
      doc.setFont("courier");
      doc.setFontSize(15);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre, 108, 12, { align: "center" });

      doc.setFontSize(14);
      doc.setFont("helvetica", "", "bold");
      doc.text(this.configuracion.empresa.subnombre, 108, 18, { align: "center" });

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "normal");
      doc.text("Campus: " + this.configuracion.sucursal.nombre, 140, 18, { align: "center" });

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.text("HORARIO DE GRUPO", 138, 24, { align: "center" });

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");
      doc.text(
        "Periodo: " +
        this.profesorhorario.periodos_escolares.nombre +
        " Carrera: " +
        this.profesorhorario.carreras_planes.carreras.nombre,
        140,
        29,
        { align: "center" }
      );
      doc.text(
        " Grupo: " +
        this.profesorhorario.grupos.clave +
        " " +
        this.profesorhorario.grupos.nivel +
        " " +
        this.profesorhorario.grupos.identificador +
        " Modalidad: " +
        this.profesorhorario.modalidades.nombre +
        " Turno: " +
        this.profesorhorario.turnos.nombre +
        " (" +
        modulo.nombre +
        " - del " +
        modulo.fecha_inicio +
        " a " +
        modulo.fecha_fin +
        ")",
        140,
        35,
        { align: "center" }
      );

      let res = (doc as any).autoTableHtmlToJson(
        document.getElementById("tablahorario" + i)
      );

      (doc as any).autoTable(res.columns, res.data, {
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: 50,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
        columnStyles: {
          0: { cellWidth: 20 }
        }
      });

      let lineas = 35 + res.data.length * 18;

      let columns = [
        { title: "Parcial", dataKey: "id" },
        { title: "Fecha de inicio", dataKey: "inicio" },
        { title: "Fecha de termino", dataKey: "termino" }
      ];
      let rows = [];
      periodos_escolares[i].periodos_escolares_parciales.forEach(par => {
        rows.push({
          id: par.numero_parcial,
          inicio: par.fecha_inicio,
          termino: par.fecha_fin
        });
      });

      (doc as any).autoTable({
            columns:columns, 
            body: rows,
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: lineas,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
        columnStyles: {
          0: { cellWidth: 20 }
        }
      });

      lineas += rows.length * 5.5;

      if (arrays.periodos_escolares.nota_alumnos) {
        arrays.periodos_escolares.nota_alumnos = arrays.periodos_escolares.nota_alumnos.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
        

        doc.fromHTML(arrays.periodos_escolares.nota_alumnos, 10, lineas + 5, {
          width: 530
        });
      }

      if (i < this.ph_modulos.length - 1) doc.addPage();
    });

    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "horario_docente.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  generarPDFTablaSemiEscolarizado() {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    let doc = new jsPDF("landscape", "mm", "letter");
    let arrays = this.dato.getRawValue();
    let periodos_escolares = arrays.modulos_periodos_escolares;

    let logo =
      this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    if (logo != "") doc.addImage(logo, "PNG", 10, 5, 26, 26, "", "FAST");

    if (this.logo_carrera != "")
      doc.addImage(this.logo_carrera, "PNG", 210, 5, 26, 26, "", "FAST");
    //Nombre empresa
    doc.setFontSize(16);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre, 140, 12, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text("Campus: " + this.configuracion.sucursal.nombre, 140, 18, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text("HORARIO DE GRUPO", 138, 24, { align: "center" });

    doc.setFontSize(8);
    doc.setFont("helvetica", "", "bold");
    doc.text("Periodo: " + this.profesorhorario.periodos_escolares.nombre + " Carrera: " + this.profesorhorario.carreras_planes.carreras.nombre, 140, 29, { align: "center" });
    doc.text(
      " Grupo: " +
      this.profesorhorario.grupos.clave +
      " " +
      this.profesorhorario.grupos.nivel +
      " " +
      this.profesorhorario.grupos.identificador +
      " Modalidad: " +
      this.profesorhorario.modalidades.nombre +
      " Turno: " +
      this.profesorhorario.turnos.nombre,
      140,
      35,
      { align: "center" }
    );
    let lineas = 44;

    let submodulos = []; let total = 0; let subtotal = 0;
    this.ph_modulos.forEach(modulo => {
      if (typeof submodulos[subtotal] == 'undefined')
        submodulos[subtotal] = [];
      submodulos[subtotal].push(modulo);
      if (total == 2) {
        total = -1;
        subtotal++;
      }
      total++;
    });

    submodulos.forEach(mod => {
      let columns = [];
      this.ph_dias.forEach(dia => {
        columns.push({
          title: dia,
          dataKey: dia
        });
      });

      (doc as any).autoTable(columns, [], {
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: lineas,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 60 }
        }
      });

      lineas += 6;
      columns = [{ title: "Hora", dataKey: "hora" }];

      mod.forEach(modulo => {
        columns.push({
          title: modulo,
          dataKey: modulo
        });
      });

      let rows = [];

      this.ph_horas.forEach(hora => {
        rows.push({});
        this.ph_dias.forEach(dia => {
          mod.forEach(modulo => {
            rows[rows.length - 1]["hora"] = hora;
            rows[rows.length - 1][modulo] = this.profesorhorario.horario[modulo][dia][hora] ? (this.profesorhorario.horario[modulo][dia][hora].nombre + '\n' + this.profesorhorario.horario[modulo][dia][hora].clave + '\n' + this.profesorhorario.horario[modulo][dia][hora].docente) : "";
          });
        });
      });

      (doc as any).autoTable({
            columns:columns, 
            body: rows,
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: lineas,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
      });
      lineas += this.ph_horas.length * 16 + 8;
    });

    this.ph_modulos.forEach((modulo, i) => {
      let columns = [
        { title: "Parcial", dataKey: "id" },
        { title: "Fecha de inicio", dataKey: "inicio" },
        { title: "Fecha de termino", dataKey: "termino" }
      ];
      let rows = [];

      periodos_escolares[i].periodos_escolares_parciales.forEach(par => {
        rows.push({
          id: par.numero_parcial,
          inicio: par.fecha_inicio,
          termino: par.fecha_fin
        });
      });

      (doc as any).autoTable({
            columns:columns, 
            body: rows,
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: lineas,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
        columnStyles: {
          0: { cellWidth: 20 }
        }
      });
      lineas += rows.length * 5.5 + 6;
    });
    if (arrays.periodos_escolares.nota_alumnos) {
      lineas += 10;
      arrays.periodos_escolares.nota_alumnos = arrays.periodos_escolares.nota_alumnos.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
      
      doc.fromHTML(arrays.periodos_escolares.nota_alumnos, 10, lineas + 5, {
        width: 530
      });
    }

    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "horario_docente.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  jsonTabla() {
    this.imprimirhorario = true;
    let ph_horas = [];
    let ph_dias = [];
    let ph_modulos = [];
    this.cargando = true;
    this.profesorhorario = this.dato.getRawValue();

    this.profesorhorario.horario = [];
    this.profesorhorario.modulos_periodos_escolares.forEach(element => {
      let elmodulo = element.fecha_inicio + " al " + element.fecha_fin;
      ph_modulos.push(elmodulo);
      if (typeof this.profesorhorario.horario[elmodulo] == "undefined")
        this.profesorhorario.horario[elmodulo] = [];

      element.horarios_dias.forEach(elem => {
        ph_dias.push(elem.dias_semanas.nombre);
        if (
          typeof this.profesorhorario.horario[elmodulo][
          elem.dias_semanas.nombre
          ] == "undefined"
        )
          this.profesorhorario.horario[elmodulo][elem.dias_semanas.nombre] = [];

        elem.horarios_detalles.forEach(el => {
          let elhora = el.hora_inicio + "-" + el.hora_termino;
          if (
            typeof this.profesorhorario.horario[elmodulo][
            elem.dias_semanas.nombre
            ][elhora] == "undefined"
          )
            this.profesorhorario.horario[elmodulo][elem.dias_semanas.nombre][
              elhora
            ] = null;
          this.profesorhorario.horario[elmodulo][elem.dias_semanas.nombre][
            elhora
          ] = {
            nombre: el.materias.nombre,
            clave: el.materias.clave,
            docente: el.personas ? el.personas.nombre : ''
          };
          ph_horas.push(elhora);
        });
      });
    });

    this.ph_horas = this.arrayUnico(ph_horas);
    this.ph_dias = this.arrayUnico(ph_dias);
    this.ph_modulos = this.arrayUnico(ph_modulos);

    setTimeout(() => {
      this.cargando = false;
      this.generarPDFTabla();
    }, 200);
  }
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }
}
